/**
 * Der Weg zur Anmeldung.
 *
 * Die Anmeldung läuft über das Backend (BFF): Es schickt den Browser zu Keycloak und
 * danach auf `redirect` zurück. Wer zur Anmeldung führt, baut die Adresse hier — nicht
 * von Hand an jeder Stelle.
 */

/** Adresse des Anmelde-Endpunkts; `redirect` ist der Pfad, auf dem es nach der Anmeldung weitergeht. */
export function loginUrl(redirect: string): string {
  return `/api/v1/auth/login?redirect=${encodeURIComponent(redirect)}`;
}

/** Wechselt zur Anmeldung. Ohne Angabe kehrt der Nutzer zur aktuellen Seite zurück. */
export function leiteZurAnmeldung(redirect: string = window.location.pathname): void {
  window.location.href = loginUrl(redirect);
}
